import { useNavigate, useSearchParams } from "react-router-dom";
import React, { useState } from "react";
import FormInputs from "../DummyReportPage/FormInputs";
import dayjs from "dayjs";
import InterogativeImg from "./../../../Assets/Images/CommanImages/Warning.png";
import ErrorImg from "./../../../Assets/Images/CommanImages/Error.png";
import EndPoints from "../../../Api/EndPoints";
import CashbookReportTable from "./CashbookReportTable";

const CashbookReport = ({
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  pauseTimer,
  resumeTimer,
  dataClient,
  setPagePath,
}) => {
  const navigate = useNavigate();
  const [resultsData, setResultsData] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [isApplied, setIsApplied] = useState(false);
  const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [isExpanded, setIsExpanded] = useState(false);
  const [value, setValues] = useState({
    month: "Month to Date",
    start_month: "",
    end_month: "",
  });

 const [searchParams] = useSearchParams();
 const reportName = searchParams.get("reportName") || "Cashbook";

  const handleRadioChange = (selectedValue) => {
    if (value.month === selectedValue) {
      setValues({ ...value, month: "" });
    } else {
      setValues({ ...value, month: selectedValue });
    }
  };

  const calculateDates = () => {
    const today = dayjs();
    let from_date = "";
    let end_date = "";

    if (!value.month) {
      return { from_date: "", end_date: "" };
    }

    end_date = today.format("YYYY-MM-DD");

    switch (value.month) {
      case "Last Month":
        from_date = today
          .subtract(1, "month")
          .startOf("month")
          .format("YYYY-MM-DD");
        end_date = today
          .subtract(1, "month")
          .endOf("month")
          .format("YYYY-MM-DD");
        break;
      case "Month to Date":
        from_date = today.startOf("month").format("YYYY-MM-DD");
        break;
      case "Week to Date":
        from_date = today.startOf("week").format("YYYY-MM-DD");
        break;
      case "Custom":
        from_date = value.start_month;
        end_date = value.end_month;
        break;
      default:
        from_date = "";
        end_date = "";
        break;
    }
    return { from_date, end_date };
  };

  const { from_date, end_date } = calculateDates();

  // Fetch PDCS list (date range is the only filter)
  const fetchPDCSData = async () => {
    setIsApplied(true);
    setIsMessageBoxVisible(true);
    setMessageBox(
      <div
        className="Container-messageBOX"
        onMouseEnter={pauseTimer}
        onMouseLeave={resumeTimer}
      >
        <div className="messagebox-insider1">
          <div className="loader-tc"></div>
          <span>Loading data, please wait...</span>
        </div>
      </div>,
    );
    setActiveImg(false);

    const dates = calculateDates();

    const queryParams = new URLSearchParams();
    if (dates.from_date) {
      queryParams.append("from_date", dates.from_date);
    }
    if (dates.end_date) {
      queryParams.append("to_date", dates.end_date);
    }
    const queryString = queryParams.toString();

    try {
      const token = localStorage.getItem("token");
      const cleanToken = token ? token.replace(/^"|"$/g, "") : "";

      const response = await fetch(
        `${EndPoints.GET_CASHBOOK_LIST}${queryString ? `?${queryString}` : ""}`,
        {
          method: "GET",
          headers: {
            accept: "*/*",
            Authorization: `Bearer ${cleanToken}`,
          },
        },
      );

      const result = await response.json();

      // Supports both { data: [[...]] } and { data: { data: [[...]] } }
      const tableData = Array.isArray(result?.data)
        ? result.data
        : result?.data?.data;

      if (Array.isArray(tableData) && tableData.length > 1) {
        setHeaders(tableData[0]);
        setResultsData(tableData.slice(1));
        setIsMessageBoxVisible(false);
      } else {
        setHeaders([]);
        setResultsData([]);
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div
            className="Container-messageBOX"
            onMouseEnter={pauseTimer}
            onMouseLeave={resumeTimer}
          >
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>No data found for the selected filters.</span>
            </div>
          </div>,
        );
        setActiveImg(InterogativeImg);
      }
    } catch (error) {
      setHeaders([]);
      setResultsData([]);
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div
          className="Container-messageBOX"
          onMouseEnter={pauseTimer}
          onMouseLeave={resumeTimer}
        >
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>{error.message || "Failed to generate report"}</span>
          </div>
        </div>,
      );
      setActiveImg(ErrorImg);
    }
  };

  const handleApplyOrReset = () => {
    if (isApplied) {
      setResultsData([]);
      setHeaders([]);
      setIsApplied(false);
      setIsColumnDivVisible(false);
      setIsMessageBoxVisible(false);
    } else {
      fetchPDCSData();
    }
  };

  const dropdownStyle = isApplied
    ? { opacity: 0.5, pointerEvents: "none" }
    : { opacity: 1, pointerEvents: "auto" };

  return (
    <div
      style={{
        height: "auto",
        width: "100%",
        paddingLeft: "36.5px",
        marginBottom: "40px",
      }}
    >
      <div style={{ position: "sticky", top: "0" }}>
        <div className="Header-up">
          <span
            style={{
              color: "#2F2E40",
              fontSize: "30px",
              textTransform: "capitalize",
            }}
          >
            {reportName}
          </span>
          <div
            className="testreportcard-header-btn-container"
            style={{ marginRight: "30px" }}
          >
            <button
              className="testreportcard-cancel-btn"
              onClick={() => {
                navigate("/report_management");
                setPagePath("Reports > Reports Dashboard");
              }}
            >
              CANCEL
            </button>

            <button
              className="testreportcard-create-btn"
              onClick={handleApplyOrReset}
            >
              {isApplied ? "RESET" : "APPLY"}
            </button>
          </div>
        </div>
      </div>

      <div style={{ display: isVisible ? "block" : "none", marginTop: "1vh" }}>
        <div
          className="grid-container-radio-button"
          style={{ marginTop: "1vh", height: "35px", ...dropdownStyle }}
        >
          <div className="item5">
            <div className="toggle-radio">
              <input
                type="radio"
                id="last month"
                name="month"
                value="Last Month"
                checked={value.month === "Last Month"}
                onClick={() => handleRadioChange("Last Month")}
                onChange={() => {}}
                disabled={isApplied}
              />
              <label htmlFor="last month">Previous Month</label>
            </div>
          </div>
          <div className="item6">
            <div className="toggle-radio">
              <input
                type="radio"
                id="month to date"
                name="month"
                value="Month to Date"
                checked={value.month === "Month to Date"}
                onClick={() => handleRadioChange("Month to Date")}
                onChange={() => {}}
                disabled={isApplied}
              />
              <label htmlFor="month to date">Month to Date</label>
            </div>
          </div>
          <div className="item7">
            <div className="toggle-radio">
              <input
                type="radio"
                id="week to date"
                name="month"
                value="Week to Date"
                checked={value.month === "Week to Date"}
                onClick={() => handleRadioChange("Week to Date")}
                onChange={() => {}}
                disabled={isApplied}
              />
              <label htmlFor="week to date">Week to Date</label>
            </div>
          </div>
          <div className="item8">
            <div className="toggle-radio">
              <input
                type="radio"
                id="custom"
                name="month"
                value="Custom"
                checked={value.month === "Custom"}
                onClick={() => handleRadioChange("Custom")}
                onChange={() => {}}
                disabled={isApplied}
              />
              <label htmlFor="custom">Custom</label>
            </div>
          </div>
          {value.month === "Custom" && (
            <>
              <div className="item9">
                <FormInputs
                  type="date"
                  name="start_month"
                  value={value.start_month}
                  onChange={(e) =>
                    setValues({ ...value, start_month: e.target.value })
                  }
                  disabled={isApplied}
                />
              </div>
              <div className="item10">To</div>
              <div className="item11">
                <FormInputs
                  type="date"
                  name="end_month"
                  value={value.end_month}
                  onChange={(e) =>
                    setValues({ ...value, end_month: e.target.value })
                  }
                  disabled={isApplied}
                />
              </div>
            </>
          )}
        </div>
      </div>
      <div style={{ position: "relative", marginTop: "20px" }}>
        <button
          style={{
            position: "absolute",
            top: "-1px",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 1,
            width: "60px",
            height: "10px",
            backgroundColor: "white",
            border: "none",
          }}
          onClick={() => {
            setIsExpanded(!isExpanded);
            setIsVisible(!isVisible);
          }}
        >
          <p style={{ fontSize: "20px", color: "black" }}>...</p>
        </button>
        <CashbookReportTable
          headers={headers.map((header) => header.substring(2))}
          data={resultsData}
          searchPlaceholder="Search by Student Name..."
          isColumnDivVisible={isColumnDivVisible}
          setIsColumnDivVisible={setIsColumnDivVisible}
          dataClient={dataClient}
          ReportPageHeader={reportName}
          course={""}
          batch={""}
          subject={""}
          chapter={""}
          dppName={""}
          student={""}
          date={
            from_date &&
            end_date &&
            dayjs(from_date).isValid() &&
            dayjs(end_date).isValid()
              ? `${dayjs(from_date).format("YYYY-MM-DD")} To ${dayjs(
                  end_date,
                ).format("YYYY-MM-DD")}`
              : ""
          }
          isExpanded={isExpanded}
        />
      </div>
    </div>
  );
};

export default CashbookReport;